import { render, staticRenderFns } from "./IssueConcessionPermit.vue?vue&type=template&id=6318b884&scoped=true"
import script from "./IssueConcessionPermit.vue?vue&type=script&lang=ts"
export * from "./IssueConcessionPermit.vue?vue&type=script&lang=ts"
import style0 from "./IssueConcessionPermit.vue?vue&type=style&index=0&id=6318b884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318b884",
  null
  
)

export default component.exports